import { css } from '@emotion/react';

const stripePaymentStyles = {
    outterBox: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    container: css({
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: '#101010',
        gap: '10px',
    }),
    header: css({
        fontSize: 20,
        fontWeight: 700,
        margin: '0 0 16px',
    }),
    formLabel: css({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: 'Montserrat',
        marginBottom: 4,
    }),
    error: css({
        fontSize: 12,
        fontWeight: 400,
        fontFamily: 'Montserrat',
        marginBottom: 4,
        color: '#C10000',
    }),
    input: css({
        backgroundColor: '#ffffff',
        padding: '15px 24px',
        color: '#000000',
        fontSize: 16,
        fontWeight: 500,
    }),
    row: css({
        marginBottom: 24,
        display: 'flex',
        justifyContent: 'space-between',
    }),
    halfRow: css({
        width: 'calc(50% - 4px)',
    }),
    toPayContainer: css({
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 24,
    }),
    toPay: css({
        fontSize: 16,
        fontWeight: 500,
    }),
    toPayAmmount: css({
        fontSize: 16,
        fontWeight: 600,
    }),
    cardNumberRow: css({
        marginBottom: 16,
    }),
    payConfirmation: css({
        fontSize: '13px',
        lineHeight: '16px',
        fontWeight: 400,
        marginBottom: '24px',
    }),
    backBtnStyles: css({
        height: '48px',
    }),
    orUseCardBlock: css({
        width: '100%',
    }),
    orUseCardContainer: css({
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '5px',
        marginBottom: '20px'
    }),
    borderLine: css({
        width: '100%',
        borderTop: '1px solid #F2F2F2',
    }),
    orUseCardText: css({
        fontSize: '13px',
        fontWeight: 400,
        color: '#000000',
        width: 'fit-content',
        whiteSpace: 'nowrap',
    })
};

export default stripePaymentStyles;
